var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g({staticClass:"os-rounded",attrs:{"type":_vm.type,"block":_vm.block,"elevation":_vm.elevation,"color":_vm.color,"loading":_vm.loading,"disabled":_vm.disabled,"dark":_vm.loading ? false : _vm.dark}},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }